import React from 'react';

interface FinishStepProps {

}

const FinishStep = ({ }: FinishStepProps) => {
    return <div></div>
}

export default FinishStep;